import type { ComponentProps } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system/components/actions';
import { Box, Flex } from '@change-corgi/design-system/layout';
import { Heading } from '@change-corgi/design-system/typography';

import { useStarterActions } from './hooks/useStarterActions';

export function StarterActions(props: ComponentProps<typeof Box>) {
	const {
		data: { declareVictoryUrl, postUpdateUrl, showActions },
	} = useStarterActions();

	if (!showActions) return null;

	return (
		<Box variant="bordered" sx={{ backgroundColor: 'neutral-grey50', maxWidth: 600 }} p={24} {...props}>
			<Box sx={{ textAlign: 'center' }}>
				<Heading as="h2" size="h5" mb={24}>
					<Translate value="fe.pages.decision_maker_response.victory_prompt.title" />
				</Heading>
			</Box>
			<Flex sx={{ flexDirection: ['column', 'row'], gap: 16 }}>
				<ButtonLink
					variant="secondaryEmphasis"
					size="small"
					to={declareVictoryUrl}
					data-qa="declare-victory-button"
					sx={{ flex: 1 }}
				>
					<Translate value="fe.pages.decision_maker_response.victory_prompt.positive" />{' '}
					<Translate value="fe.pages.decision_maker_response.victory_prompt.positive_cta" />
				</ButtonLink>
				<ButtonLink
					variant="secondaryEmphasis"
					size="small"
					to={postUpdateUrl}
					data-qa="post-update-button"
					sx={{ flex: 1 }}
				>
					<Translate value="fe.pages.decision_maker_response.victory_prompt.negative" />{' '}
					<Translate value="fe.pages.decision_maker_response.victory_prompt.negative_cta" />
				</ButtonLink>
			</Flex>
		</Box>
	);
}
